import { buildStandardReducer, buildTypes } from 'utils/reducer-utils';

export default buildStandardReducer(buildTypes('tickets'));
